import userimg from "src/img/user.png";

export default function Profile({
    value, 
    side, 
    className
}:{
    value: string,
    side: number,
    className?: string
}){
    return value?
    <img
        src = {value}
        alt = {""}
        height = {side}
        width = {side}
        className = {`rounded me-2 ${className}`}
    />
    :
    <img
        src = {userimg}
        alt = {""}
        height = {side}
        width = {side}
        className = {`rounded me-2 ${className}`}
    />
}